import React, { useContext } from "react";
import "./Styles/Header.css";
import logo from "../Images/Logos/AM2 Logo Horizontal Colour Light.png";

import { Text, Icon } from "@fluentui/react";
import { getTheme } from "@fluentui/react";

import { MenuContext } from "./Contexts/MenuContext";
import { FrameContext } from "./Contexts/FrameContext";

export const Header = () => {
  const [menuContext, setMenuContext] = useContext(MenuContext);
  const [frameContext] = useContext(FrameContext);

  return (
    <header
      className="Header"
      style={{ backgroundColor: getTheme().palette.white }}
    >
      <div className="Header-left">
        <div
          className="Header-left-burger"
          onClick={() => setMenuContext({ ...menuContext, isMenuOpen: true })}
        >
          <BurgerIcon />
        </div>
        <div className="Header-left-logo">
          <a
            href={`?name=${menuContext.home?.text}&url=${menuContext.home?.href}`}
          >
            <img src={logo} alt="logo" />
          </a>
        </div>
      </div>
      <div className="Header-middle">
        <Text
          variant="xxLarge"
          styles={{
            root: {
              color: getTheme().palette.black,
              fontFamily: "Poppins",
              fontWeight: "bold",
            },
          }}
        >
          {frameContext.frameName}
        </Text>
      </div>
      <div className="Header-right"></div>
    </header>
  );
};

const BurgerIcon = () => (
  <Icon
    iconName="CollapseMenu"
    styles={{
      root: { color: getTheme().palette.neutralPrimary },
    }}
  />
);
